import { z } from 'zod/v4';

export const userVehicleSchema = z.object({
  isActive: z.boolean(),
  modifiedOn: z.string().nullable(),
  vehicleDeviceId: z.string().min(1),
  vehicleId: z.number().min(1),
  vehicleName: z.string().min(1),
});

export type UserVehicle = z.infer<typeof userVehicleSchema>;
